import { Button, Box, Icon, Tooltip } from '@wegroup/design-system';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import useMobileBreakpoints from '../../../common/src/hooks/useMobileBreakpoints';
import CompanyScanBottomBarWrapper from '../../../flows/src/components/ui/company-scan/components/bottom-bar/CompanyScanBottomBarWrapper';

// TODO: Remove all these props and let the component be used differently
interface Props {
  onPreviousClick?: () => void;
  onNextClick?: () => void;
  nextText?: string;
  disabledPrevious?: boolean;
  disabledNext?: boolean;
  isLoadingNext?: boolean;
  nextTooltipText?: string;
  previousText?: string;
}

const CompanyScanBottomBar: React.FC<React.PropsWithChildren<Props>> = ({
  onPreviousClick,
  onNextClick,
  disabledPrevious,
  disabledNext,
  isLoadingNext,
  nextText,
  nextTooltipText,
  previousText,
}) => {
  const { t } = useTranslation();
  const { isTablet } = useMobileBreakpoints();

  return (
    <CompanyScanBottomBarWrapper>
      {onPreviousClick && (
        <Button
          variant="secondary"
          minW={isTablet ? '152px' : 'unset'}
          justifySelf="flex-start"
          onClick={onPreviousClick}
          borderRadius="full"
          leftIcon={<Icon name="GeneralActionsArrowLeft" boxSize={5} />}
          isDisabled={disabledPrevious}
        >
          {isTablet && (previousText || t('PREVIOUS'))}
        </Button>
      )}
      {onNextClick && (
        <Box justifySelf="flex-end" gridColumnStart="3">
          <Tooltip
            label={nextTooltipText}
            isDisabled={!disabledNext}
            shouldWrapChildren
          >
            <Button
              data-test-id="COMPANY-SCAN_BOTTOM-BAR_ACTION-BUTTON_NEXT"
              minW="152px"
              onClick={onNextClick}
              borderRadius="full"
              rightIcon={<Icon name="GeneralActionsArrowRight" boxSize={5} />}
              isDisabled={disabledNext}
              isLoading={isLoadingNext}
            >
              {nextText ? nextText : t('NEXT')}
            </Button>
          </Tooltip>
        </Box>
      )}
    </CompanyScanBottomBarWrapper>
  );
};

export default memo(CompanyScanBottomBar);
